import React, { FC } from "react";
import ListBlock from "../common/F7/ListBlock";
import ListBlockItem from "../common/F7/ListBlockItem";
import Page from "../common/navigation/Page";
import Spinner from "../common/F7/Spinner";
import Button from "../common/F7/Button";
import BackButton from "../common/navigation/BackButton";
import usePermissions from "../../hooks/usePermissions";
import { useListProjects } from "../../hooks/database/usePouchList";

const ProjectListPage: FC = () => {
  const { canAddProject } = usePermissions();

  const { data: projects } = useListProjects();

  if (!projects) {
    return <Spinner />;
  }

  return (
    <Page navbarLeft={<BackButton />} title="Projects">
      <ListBlock>
        {projects.map((project) => (
          <ListBlockItem key={project._id} title={project.name} to={project._id} />
        ))}
      </ListBlock>
      {canAddProject ? <Button to="new">Add Project</Button> : null}
    </Page>
  );
};

export default ProjectListPage;
